/**
 * @todo (vue3): Uses `process.env.*` instead of `import.meta.env` only because
 *       Jest cannot parse import.meta. Switch when tests move to Vitest; the
 *       `define` block in vite.config.mts is what keeps this working.
 */
export const bakedClientVersion = process.env.VUE_APP_RELEASE || ''

export default () => ({
  // Was `!!window.webpackHotUpdate`, a webpack dev-server runtime global that
  // does not exist under Vite. NODE_ENV yields the same value in every
  // environment: true under the dev server, false in production and in Jest.
  isInDevelopmentMode: process.env.NODE_ENV === 'development',
  initialized: false,
  clientVersion: bakedClientVersion,
  jobDataLastFetch: null,
  invoiceDataLastFetched: null,
})
